import React, { useState } from "react";
import "./ToolTip.scss";

const Tooltip = (props : any) => {
  let timeout :any;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 300);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    <div
      className="tooltip-wrapper"
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
      data-testid="tooltip-wrapper"
    >
      {props.children}
      {active && (
        <div className={`tooltip-tip ${props.direction || "top"}`}>
          {props.content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
